<div class="xi-modal__container" *transloco="let t; read: 'create-action-plan-dialog-component'">
  @if (currentStep === 1) {
    <h2 class="xi-modal__title">{{ titleLabel }}</h2>
    <div class="xi-modal__content">
      <form autocomplete="off" [formGroup]="form" class="create-action-plan__content">
        <div>
          <label class="kxi-input-label kxi-normal-contrast">{{ t('breakdown-field') }}</label>
          <app-lex-blue-pill [text]="selectedBreakdown"></app-lex-blue-pill>
        </div>
        <div>
          <label class="kxi-input-label kxi-normal-contrast">{{ t('driver') }}</label>
          <app-lex-blue-pill [text]="driver.fieldLongName"></app-lex-blue-pill>
        </div>
        <xi-date-picker
          [direction]="3"
          [status]="dueDateStatus"
          [minDate]="actionPlanMinDueDate"
          (focusout)="onDueDateFocusOut()"
          label="{{ t('date-label') }}"
          [dateValue]="form.controls.actionPlanDueDate.value"
          formControlName="actionPlanDueDate"
          placeholder="{{ t('date-placeholder') }}"
        ></xi-date-picker>
        <div class="create-action-plan__scores">
          <div>
            <label class="kxi-input-label kxi-normal-contrast">{{
              t('current-score', { currentScoringStrategyText })
            }}</label>
            <app-lex-blue-pill
              [text]="driver.current | number: '1.0-1'"
              textAlign="center"
            ></app-lex-blue-pill>
          </div>
          <div>
            <label class="kxi-input-label kxi-normal-contrast">{{
              t('target-score', { targetScoringStrategyText })
            }}</label>
            <app-lex-horizontal-stepper
              [value]="simulatedValue"
              [originalValue]="driver.current"
              [scale]="scale"
              size="normal"
              [disabled]="isSaving"
              [allowNegative]="scoringStrategy === 'NPS'"
              [allowFractional]="true"
              [decimals]="1"
              (valueChange)="onSimulatedValueChanged($event)"
              (modeChange)="onStepperModeChanged($event)"
            ></app-lex-horizontal-stepper>
          </div>
        </div>
        <div
          class="xi-input-field-wrapper create-action-plan__wide-input create-action-plan__tall-input"
        >
          <xi-text-area
            label="{{ t('note-label') }}"
            formControlName="actionPlanNote"
            placeholder="{{ t('note-placeholder') }}"
            type="text"
          >
          </xi-text-area>
        </div>
      </form>
    </div>
    <div class="xi-modal__actions create-action-plan__first-step-actions">
      <xi-default-button
        text="{{ t('cancel') }}"
        fill="text"
        (onClick)="onCancel()"
      ></xi-default-button>
      <div class="xi-loader-button-container">
        <xi-default-button
          [text]="saveLabel"
          [disabled]="!form.controls.actionPlanDueDate.value || isSaving || stepperMode === 'edit'"
          (onClick)="onCreatePlan()"
        >
        </xi-default-button>
        @if (isSaving) {
          <div class="xi-loader-container__inline-overlay">
            <xi-animation
              [height]="75"
              [width]="75"
              [loop]="true"
              animation="cx_loader"
            ></xi-animation>
          </div>
        }
      </div>
    </div>
  }
  @if (currentStep === 2) {
    <div class="xi-modal__content create-action-plan__content-svg">
      <xi-svg svg="celebration"></xi-svg>
    </div>
    <h2 class="xi-modal__title create-action-plan__done-title">
      <div>{{ t('target-score', { targetScoringStrategyText }) }}</div>
      <div class="create-action-plan__sub-title">
        {{ selectedBreakdown }} - {{ driver.fieldLongName }}
      </div>
    </h2>
    <div class="xi-modal__actions">
      <xi-default-button
        text="{{ t('back-to-dashboard') }}"
        (onClick)="onBack()"
      ></xi-default-button>
      <xi-default-button
        fill="text"
        text="{{ t('go-to-action-plan') }}"
        (onClick)="onGoToPlan()"
      ></xi-default-button>
    </div>
  }
</div>
